import { LinearProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

const RoundedLinearProgress = withStyles(() => ({
  root: {
    height: 7,
    borderRadius: 5,
    backgroundColor: '#e0e0e0'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#3C52EF'
  }
}))(LinearProgress)

export default RoundedLinearProgress
